<template>
  <header></header>
</template>

<style scoped>
header {
  width: 100%;
  height: 20vh;
  background-image: url("../assets/bg-header-desktop.svg");
  background-repeat: repeat;
  background-color: var(--DesaturatedDarkCyan);
}
header img {
  height: 100%;
  width: 100%;
}
</style>
